import {Component, Inject} from '@angular/core';
import {MODAL_DATA, NgbActiveModal} from '@agilent/ui-element';

@Component({
    selector: 'app-required-software-notification',
    template: `
        <ag-dialog header="Required Updates">
            <ag-dialog-content>
                <p>
                    To run this command, the following software versions are required:
                </p>
                <ul *ngFor="let key of keys(); ">
                    <li>
                        <span>{{getReadableKeyName(key)}}:<code> {{requirements[key]}}</code> or later.</span>
                    </li>
                </ul>
            </ag-dialog-content>
            <ag-dialog-actions>
                <ag-button type="secondary" (click)="dismiss()" value="Dismiss"></ag-button>
            </ag-dialog-actions>
        </ag-dialog>`
})
export class RequiredSoftwareNotificationComponent {
    public requirements: {};
    public doNotAskAgain = false;

    constructor(
        private activeModal: NgbActiveModal,
        @Inject(MODAL_DATA) private modalData: any
    ) {
        this.requirements = modalData.requirements;
    }

    keys(): Array<string> {
        return Object.keys(this.requirements);
    }

    getReadableKeyName(key) {
        switch (key) {
            case 'aic_software':
                return 'AIC Software';
            case 'agent_software':
                return 'Agent Software';
            case 'update_agent_software':
                return 'Update Agent Software';
            default:
                return key;
        }
    }

    dismiss() {
        this.activeModal.dismiss();
    }

}
